export const deleteCookie = (
  name: string,
  path: string = "/",
  domain?: string,
): void => {
  let cookieString = `${name}=; Max-Age=0; path=${path};`;
  if (domain) {
    cookieString += ` domain=${domain};`;
  }
  document.cookie = cookieString;

  const pastDate = new Date(0).toUTCString();
  cookieString = `${name}=; expires=${pastDate}; path=${path};`;
  if (domain) {
    cookieString += ` domain=${domain};`;
  }
  document.cookie = cookieString;
};
